import * as actions from './actions';

export default {
  strict: true,
  state: {
    isFetchingPromos: false,
  },
  actions,
  mutations: {
    'promos/set' (state, { path, value }) {
      state[path] = value;
    },
  },
};
